module.exports = __webpack_public_path__ + "img/V98.d58b85fc.jpg";